import React, { useState, useEffect} from 'react'
import {Row,Col, Modal} from 'react-bootstrap'
import Card from '../../../components/Card'
import { getApiCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import {getUser } from '../../../utilities/setting';
import { toast } from 'react-toastify';
import { USER_ROLES ,NUMBERS_TYPES,NUBMERS_STATUS_LABEL, USERS_ROLE} from '../../../utilities/constant';
import Loader  from '../../../components/partials/components/loader';
import { useNavigate,useParams } from "react-router-dom";
import { errorCheck } from '../auth/auth-utils';
import { postApiCall} from "../../../service/httpCall";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { API_TO_ALLOCATE_NUMBERS ,API_DID_MAPPING, API_ALLOCATED_NUMBERS,
    API_REMOVE_NUMBERS, API_VOICE_PLAN_LIST, API_COMPANY_LIST, API_TO_GET_REMOVE_NUMBERS,
    API_CALL_CENTRE_LIST, API_VOICE_PLAN_EDIT} from "../../../service/url";
import "../../../assets/custom/css/custom.css";
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import { MultiSelect } from 'primereact/multiselect'; 
import { TabView, TabPanel } from 'primereact/tabview';
import { PrimeIcons } from 'primereact/api';


const numberTypeLabels = NUMBERS_TYPES.map(val => val['label']);
const categoryLabels = ['Free', 'Paid'];
const currencyLabels =['INR','USD'];

const UserAllocate = () =>{
   const navigate = useNavigate();
   const routerParams = useParams();
   const [userRole, setUserRole] = useState('');
   const [numbersList, setNumbersList] = useState([]);
   const[filters,setFilters] =useState({
    actual_number: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    state_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    number_type: { value: "DID", matchMode: FilterMatchMode.EQUALS },
    category: { value: null, matchMode: FilterMatchMode.EQUALS },
    currency: { value: null, matchMode: FilterMatchMode.EQUALS },
    cost: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    operator: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
});
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [selectedNumbers, setSelectedNumber] = useState([]);
   const [comingUserRole, setComingUserRole] = useState('');
   const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
   const [isViewingAllocated, setIsViewingAllocated] = useState(false);
   const [currentUserId,setCurrentUserId] = useState(undefined);
   const [showModal, setShowModal] =useState(false);
   const [selectedAllocations , setSelectedAllocations] = useState([]);
   const [showRemoveButton , setShowRemoveButton] = useState(false);
   const [allocatedNumber, setAllocatedNumber] = useState([]);
   const [activeIndex, setActiveIndex] = useState(0);
   const [voicePlan, setVoicePlanModel] =useState("");
   const [voicePlanList, setVoicePlanList] = useState([]);
   const [selectedPlan, setSelectedVoicePlan] = useState("");
   const [allocationResult, setAllocationResult] = useState(null);
   const [showResultModal, setShowResultModal] = useState(false);
   const [companyList, setCompanyList] = useState([]);
   const [selectedCompany, setSelectedCompany] = useState("");
   const [callcenterList, setCallcenterList] = useState([]);
   const [selectedCallcenter, setSelectedCallcenter] = useState("");
   const [isReseller, checkIsReseller] = useState(false);
   const [isCompanyUser, checkIsCompanyUser] = useState(false);
   const [showPlanModal, setShowPlanModal] = useState(false);
   const [selectedPlanDetails, setSelectedPlanDetails] = useState([]);
   const [selectedPlanName, setSelectedPlanName] = useState('');
   const [editVoicePlanModel, setEditVoicePlanModel] =useState("");
   const [selectedEditPlan, setSelectedEditVoicePlan] = useState("");
   const [editPlanNumber, setEditPlanNumber] = useState("");
   const [editPlanIconId, setEditPlanIconId] = useState("")
   const [toAllocateId, setToAllocateId] = useState("");
   const [parentVoicePlan, setParentVoicePlan] = useState(null);

   useEffect(() => {
        getUser().then((user) => {
        const {id, currentId, role} = routerParams;
        const idToCheck = isSuperAdmin ? id : currentId
        console.log("idToCheck", idToCheck, id, currentId, role);
        setSelectedCompany(currentId)
        setSelectedCallcenter(id)
        setComingUserRole(role)

        if (user) {
            if (user.role === USER_ROLES.SUPERADMIN) {
            checkIsSuperAdmin(true);
            setCurrentUserId(user.id);
            }
            setUserRole(user.role);
            if (user.role === USER_ROLES.RESELLER) {
            checkIsReseller(true)
            setCurrentUserId(user.id);
            }
            if (user.role === USER_ROLES.COMPANY_ADMIN) {
              checkIsCompanyUser(true)
            }

            if (user.role !== USER_ROLES.RESELLER  && user.role !== USER_ROLES.SUPERADMIN) {
                setCurrentUserId(idToCheck);
            }
        }

        // if (role === 'company') {
        //     setToAllocateId(user.company_id)
        // } else {
        //     setToAllocateId(user.callcenter_id)
        // }
        setToAllocateId(user.company_id)

        });
    }, []);

    useEffect(() => {
         getApiCall(API_VOICE_PLAN_LIST)
        .then(onVoicePlanSuccess)
        .catch(onError)
    }, [])

    function onVoicePlanSuccess(resp) {
        setVoicePlanList(resp);
    }

    useEffect(() => {
        getApiCall(API_COMPANY_LIST)
       .then(onCompanyListSuccess)
       .catch(onError)
   }, [])

   function onCompanyListSuccess(resp) {
       setCompanyList(resp);
   }

   useEffect(() => {
    getApiCall(API_CALL_CENTRE_LIST)
   .then(onCallcenterListSuccess)
   .catch(onError)
    }, [])

    function onCallcenterListSuccess(resp) {
    setCallcenterList(resp);
    }

 
   
//    useEffect(() => {
//         if (toastProps) {
//             setShowToast(true);
//         }
//     }, [toastProps]);


    useEffect(() => {
        if(currentUserId){
            getApiCall(`${API_TO_ALLOCATE_NUMBERS}/${toAllocateId}`)
        .then(onNumberListSuccess)
        .catch(onError)
        .finally(() => setLoading(false));
        }
    }, [currentUserId])

    function onNumberListSuccess(resp) {
        const updatedList = resp.map((val, idx) => {
            val['key'] = idx + 1;
            val['created_at'] = new Date(val['created_at']).toGMTString();
            return val;
        });
        setNumbersList(updatedList);
    }
  

    const handleAllocate = () => {
        const {id} = routerParams;
        const selectedDID = selectedNumbers;
        console.log('selectedDID', selectedDID)
        if(selectedDID.length === 0) {
            toast.error("No number selected for allocation");
            setShowToast(true);
            return;
        }
        if(!selectedPlan && (isReseller || isSuperAdmin)) {
            toast.error("No voice plan selected for allocation");
            setShowToast(true);
            return;
        }
        let params
        // if (isSuperAdmin || (isReseller && comingUserRole === USER_ROLES.RESELLER)) {
        //     params ={
        //         DID : selectedDID,
        //         allocated_to : id,
        //         voice_plan_id: selectedPlan,
        //         allocated_to_role: USER_ROLES.RESELLER
        //     }
        // } else
        if (comingUserRole === 'callcentre') {
            params ={
                DID : selectedDID,
                allocated_to : selectedCallcenter,
                voice_plan_id: selectedPlan,
                allocated_to_role: 'callcentre'
            }
        } else {
            params ={
                DID : selectedDID,
                allocated_to : selectedCompany,
                voice_plan_id: selectedPlan,
                allocated_to_role: 'company'
            }
        }
        if (!params.allocated_to) {
            toast.error("Allocated user is missing");
            return;
        }
        
    
        postApiCall(API_DID_MAPPING, params)
        .then((resp) => {
            setAllocationResult(resp)
            const numberType = numbersList.find(number => selectedDID.includes(number.id))?.number_type || 'Number';
            if (resp?.successDIDs?.length > 0 || resp?.successActualNumbers?.length > 0) {
            toast.success(`${numberType}(s) allocated successfully`);
            } else {
            toast.error(`Failed to allocate numbers`);
            }
            setShowToast(true);
            const updatedNumbersList = numbersList.filter(number => !resp.successDIDs.includes(number.id));
            setNumbersList(updatedNumbersList);
            setSelectedNumber([]);
            setSelectedVoicePlan('');
            // setSelectedCompany('')
            setVoicePlanModel(false)
            setShowResultModal(true)
        })
        .catch(error => {
            toast.error(`Failed to allocate numbers: ${error}`);
            setShowToast(true);
        })
        .finally(() => setLoading(false));
    };
    
    const handleAllocatedToUser = () => {
        const { id , currentId, role} = routerParams;
        const idToCheck = (role === 'company' ? currentId : id)
        setEditPlanIconId(idToCheck)
        
        // Clear existing data and show loading immediately
        setNumbersList([]);
        setLoading(true);
        setIsViewingAllocated(true);

        getApiCall(`${API_ALLOCATED_NUMBERS}/${idToCheck}/${role}`)
            .then((resp) => {
                setShowRemoveButton(resp.is_removal_button)
                onNumberListSuccess(resp.data);

            })
            .catch(onError)
            .finally(() => setLoading(false));
    }

    const handleBackToAvailableNumbers = () => {
        // Clear existing data and show loading immediately
        setNumbersList([]);
        setLoading(true);
        setIsViewingAllocated(false);
        
        getApiCall(`${API_TO_ALLOCATE_NUMBERS}/${toAllocateId}`)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));
    }

    const handleRefresh = () => {
        // Clear existing data and show loading immediately
        setNumbersList([]);
        setLoading(true);
        setIsViewingAllocated(false);
        
        getApiCall(`${API_TO_ALLOCATE_NUMBERS}/${toAllocateId}`)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));
    }

   const dropdownItemTemplate = (option) => {
      return <span>{option}</span>;
   }


    const numberTypeFilterTemplate = options => {
        return <Dropdown value={options.value} options={numberTypeLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
    }
    const categoryFilterTemplate = options => {
        return <Dropdown value={options.value} options={categoryLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Category" className="p-column-filter" showClear />;
    }
    const currencyFilterTemplate = options => {
        return <Dropdown value={options.value} options={currencyLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Currency" className="p-column-filter" showClear />;
    }
    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={NUBMERS_STATUS_LABEL} onChange={(e) => options.filterCallback(e.value)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
    }
   
   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        console.log(err)
      }
   }

   
   const handleCheckboxToggle = (numberId) => {
    const isSelected = selectedNumbers.includes(numberId);
    setSelectedNumber(isSelected
        ? selectedNumbers.filter(id => id !== numberId)
        : [...selectedNumbers, numberId]);
   };

   const handleNumberTypeFilter = (type) => {
        setIsViewingAllocated(false);
        setFilters((prevFilters) => ({
            ...prevFilters,
            number_type: { value: type, matchMode: FilterMatchMode.EQUALS },
        }));
    };

   const handleSelectAll = () => {
        if (selectedNumbers.length === numbersList.length) {
            setSelectedNumber([]);
        } else {
            const allNumberIds = numbersList.map(number => number.id);
            setSelectedNumber(allNumberIds);
        }
    };


    const getButtonLabel = () => {
        const {role} = routerParams;
        if (role === 'company') {
            return "Allocate To Company";
        } else {
            return "Allocate To Callcentre";
        }
        
        // switch (role) {
        //     case USER_ROLES.RESELLER:
        //         return "Allocate To Reseller"
        //     case USER_ROLES.COMPANY_ADMIN:
        //         return "Allocate to Company User";
        //     case USER_ROLES.CALL_CENTRE_ADMIN:
        //         return "Allocate to Call Centre";
        //     default:
        //         return "Allocate";
        // }

    };


    const handleOpenModal = () => {
        setShowModal(true); 
    };

    const handleCloseModal = () => {
        setSelectedAllocations([]);
        setShowModal(false); 
    };

    const handleCloseVoicePlanModal = () => {
        // setSelectedAllocations([]);
        setVoicePlanModel(false); 
        setSelectedVoicePlan('')
    };

    useEffect(() => {
        const {id, currentId, role} = routerParams
        const idToCheck = (role === 'company' ? currentId : id)
        if(id) {
            getApiCall(`${API_TO_GET_REMOVE_NUMBERS}/${idToCheck}`)
        .then((resp) => {
            const updatedList = resp.map((val, idx) => {
                val['key'] = idx + 1;
                val['created_at'] = new Date(val['created_at']).toGMTString();
                return val;
            });
            setAllocatedNumber(updatedList);
        })
        .catch(onError)
        .finally(() => setLoading(false));
        }
    }, [showModal])

    const handleRemoveAllocatedDIDs =() =>{
        const { id, currentId, role } = routerParams;
        const idToCheck = (role === 'company' ? currentId : id)

        if(selectedAllocations.length === 0){
            toast.error('No DID selected for removal');
            setShowToast(true);
            return;
        }
 
        setLoading(true);

        const params = {
            DID: selectedAllocations,
            user_id: idToCheck,
            from_remove_role : role
        };

        postApiCall(API_REMOVE_NUMBERS, params)
        .then(() => {
            toast.success('DID(s) removed successfully');
            setShowToast(true);

            const updatedNumbersList = numbersList.filter(number => !selectedAllocations.includes(number.id));
            setNumbersList(updatedNumbersList);
            setSelectedAllocations([]);
            setShowModal(false);
        })
        .catch((error) => {
            toast.error(`Failed to remove DID(s): ${error}`);
            setSelectedAllocations([]);
            setShowModal(false);
        })
        .finally(() => setLoading(false));

        
        
            
    }

   const rowClassName = (data) => {
      return {
          'highlighted-row': selectedNumbers.includes(data.id)
        };
    }
       
    if (loading) {
      return <Loader />
    }

   const handleEditPlan = (planName, numberId) => {
        setEditPlanNumber(numberId)
        const filteredPlans = voicePlanList.filter(plan => plan.plan_name !== planName);
        setVoicePlanList(filteredPlans);
        setEditVoicePlanModel(true); 
    };

    const handleUpdateVoicePlan = () => {
        
        const params = {
            DID : editPlanNumber,
            voice_plan_id: selectedEditPlan
        }
        
    
        postApiCall(`${API_VOICE_PLAN_EDIT}/${editPlanNumber}`, params)
        .then((resp) => {
            setEditVoicePlanModel(false);
            setSelectedEditVoicePlan(false);
            setEditPlanNumber(false);
            handleAllocatedToUser();
            toast.success(`Voice Plan Updated successfully`);
            setShowToast(true);
        })
        .catch(error => {
            toast.error(`Failed to Update Voice Plan: ${error}`);
            setShowToast(true);
        })
        .finally(() => setLoading(false));
    };

  // Mirror backend validation to decide if a child plan is invalid vs parent
  const shouldDisablePlan = (plan) => {
    // If we don't know the parent plan or plan details, don't disable anything
    if (
      !parentVoicePlan ||
      !Array.isArray(parentVoicePlan.plans) ||
      !Array.isArray(plan.plans)
    ) {
      return false;
    }

    // For each plan_type in the child plan, enforce same rules as backend
    for (const child of plan.plans) {
      const parent = parentVoicePlan.plans.find(
        (p) => p.plan_type === child.plan_type
      );

      // No matching plan_type in parent => invalid
      if (!parent) {
        return true;
      }

      // Child cannot be "less" than parent:
      // - pulse_price must be >= parent's
      // - pulse_duration must be >= parent's
      if (Number(child.pulse_price) < Number(parent.pulse_price)) {
        return true;
      }

      if (Number(child.pulse_duration) < Number(parent.pulse_duration)) {
        return true;
      }
    }

    // All checks passed → allowed
    return false;
  };

  const voicePlanOptions = voicePlanList.map((plan) => ({
    label: plan.plan_name,
    value: plan.id,
    disabled: shouldDisablePlan(plan),
  }));

  return(
    <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between align-items-center">
                     <div className="header-title">
                     <h4 className="card-title">
                        {comingUserRole === 'company'
                            ? 'Allocate Number to Company' : 'Allocate Number to Call Centers'
                        }
                      </h4>
                     </div>
                     <div>
                     {isViewingAllocated && numbersList.length > 0 && showRemoveButton && (
                    <button className="btn btn-primary me-2" onClick={handleOpenModal}>Remove Number</button>
                    )}
                     </div>
                  </Card.Header>
                  {/* {!isReseller || !isSuperAdmin && ( */}

                  {/* )} */}

                  <Card.Body className="px-0">
                   <div className="custom-tab-container">
                        <Row className="d-flex align-items-center">
                            <Col>
                                <Button
                                    label="Free Numbers"
                                    onClick={handleRefresh}
                                    className="p-button-primary p-button-sm"
                                    disabled={selectedNumbers?.length > 0}
                                    style={{ marginBottom: '10px', marginLeft: '10px' }}
                                />
                                <Button
                                  label={getButtonLabel()}
                                  onClick={() => {
                                    // Original logic for allocating numbers
                                    if (isSuperAdmin || isReseller) {
                                      // Determine parent voice plan from the first selected DID
                                      if (selectedNumbers.length > 0) {
                                        const firstDidId = selectedNumbers[0];
                                        const parentNumber = numbersList.find(
                                          (num) => num.id === firstDidId
                                        );

                                        // Use the voice_plan object attached from backend (includes plans)
                                        if (parentNumber && parentNumber.voice_plan) {
                                          setParentVoicePlan(parentNumber.voice_plan);
                                        } else {
                                          setParentVoicePlan(null);
                                        }
                                      } else {
                                        setParentVoicePlan(null);
                                      }

                                      setVoicePlanModel(true);
                                    } else {
                                      handleAllocate();
                                    }
                                  }}
                                  className="p-button-primary p-button-sm"
                                  style={{ marginBottom: '10px', marginLeft: '10px' }}
                                  disabled={selectedNumbers.length === 0}
                                />
                                <Button
                                    label="Allocated Numbers"
                                    onClick={handleAllocatedToUser}
                                    className="p-button-primary p-button-sm"
                                    style={{ marginBottom: '10px', marginLeft: '10px' }}
                                    disabled={selectedNumbers?.length > 0}
                                />
                            </Col>
                            {(!isSuperAdmin && !isReseller) && (
                            <Col>
                                <div 
                                    style={{
                                        background: "#FFF8C6",
                                        color: "#8B5A2B",
                                        padding: "10px 15px",
                                        borderRadius: "6px",
                                        marginRight: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        //   marginTop:"70px",
                                        //   marginBottom:"20px"
                                        }}
                                    >
                                        <span><strong>Note:</strong> Allocated numbers will use the parent's Applied Voice plan by default.</span>
                                </div>
                            </Col>
                            )}

                        </Row>     
                        <TabView 
                            activeIndex={activeIndex} 
                            onTabChange={(e) => {
                            setActiveIndex(e.index)
                            handleNumberTypeFilter(["DID", "VMN", "TOLL FREE"][e.index])}}>
                            {["DID", "VMN", "TOLL FREE"].map((tab, index) => (
                                <TabPanel
                                    key={index}
                                    header={
                                        <span
                                            style={{
                                                display: "inline-block",
                                                borderRadius: "5px",
                                                fontWeight: activeIndex === index ? "bold" : "normal",
                                                border: 'none'
                                            }}
                                            >
                                            {tab}
                                        </span>
                                    }
                                >
                                <div className="scroll-container">
                                    <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName = {rowClassName}>
                                        {(!isViewingAllocated && (isSuperAdmin || [USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN, USER_ROLES.CALL_CENTRE_ADMIN].includes(userRole))) && (
                                            <Column 
                                                header={<Checkbox 
                                                checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                onChange={handleSelectAll} 
                                            />} 
                                            headerStyle={{ width: '3rem' }} 
                                            body={(rowData) => (
                                            <Checkbox 
                                                checked={selectedNumbers.includes(rowData.id)} 
                                                onChange={() => handleCheckboxToggle(rowData.id)} 
                                            />
                                            )} 
                                            />
                                        )} 
                                                                        
                                        <Column field="actual_number" filterField="actual_number" header="DID" filter filterPlaceholder="Search by Number" body={(rowData) => rowData.actual_number || '-'}></Column>
                                        <Column field="country_code" filterField="country_code" header="Country Code" filter filterPlaceholder="Search by Country Code" body={(rowData) => rowData.country_code || '-'}></Column>
                                        <Column field="state_code" filterField="state_code" header="State Code" filter filterPlaceholder="Search by State Code" body={(rowData) => rowData.state_code || '-'}></Column>
                                        <Column field="cost" filterField="cost" header="Cost" filter filterPlaceholder="Search by Cost" body={(rowData) => rowData.cost || '-'}></Column>
                                        <Column field="operator" filterField="operator" header="Operator" filter filterPlaceholder="Search by Operator" body={(rowData) => rowData.operator || '-'}></Column>
                                        <Column field="category" filterField="category" header="Category" filter filterPlaceholder="Search by Category" filterElement={categoryFilterTemplate} body={(rowData) => rowData.category || '-'}></Column>
                                        <Column field="currency" filterField="currency" header="Currency" filter filterPlaceholder="Search by Currency" filterElement={currencyFilterTemplate} body={(rowData) => rowData.currency || '-'}></Column>
                                       
                                        <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                   <Column
                                                        field="status"
                                                        header="Status"
                                                        filterElement={statusFilterTemplate}
                                                        filter
                                                        body={(rowData) => {
                                                            return rowData.allocated_to === null ? 'Available' : 'Allocated';
                                                        }}
                                                    />
                                        <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                        <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type"  body={(rowData) => rowData.routing_type || '-'}></Column>
                                        <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing"  body={(rowData) => rowData.routing_destination || '-'}></Column>
                                        <Column field="created_at" header="Created Date" body={(rowData) => {
                                            if (!rowData.created_at) return '-';
                                            const date = new Date(rowData.created_at);
                                            return date.toLocaleString("en-IN", {
                                                timeZone: "Asia/Kolkata",
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: true
                                            });
                                        }}></Column>
                                        <Column
                                            field="voice_plan.plan_name"
                                            header="Plan Name"
                                            body={(rowData) => {
                                                const planName = rowData?.voice_plan?.plan_name;
                                                return planName ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <button
                                                    onClick={() => {
                                                        setSelectedPlanDetails(rowData.voice_plan.plans || []);
                                                        setSelectedPlanName(planName);
                                                        setShowPlanModal(true);
                                                    }}
                                                    style={{
                                                        // backgroundColor: '#f0f0f0',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                    }}
                                                    >
                                                    {planName}
                                                    </button>
                                                    {editPlanIconId == rowData?.allocated_to && (
                                                        <i
                                                        className="fa fa-edit"
                                                        onClick={() => handleEditPlan(rowData?.voice_plan?.plan_name, rowData?.id)}
                                                        style={{ cursor: 'pointer', color: '#333' }}
                                                        ></i>
                                                    )}
                                                    
                                                </div>
                                                ) : null;
                                            }}
                                        />

                                            {isViewingAllocated && (
                                                <Column field="allocated_name" header="Allocated To"></Column> 
                                            )}
                                            {isViewingAllocated && (
                                                <Column field="allocated_by" header="Allocated By"></Column> 
                                            )}

                                    </DataTable>
                                </div>
                            </TabPanel>
                        ))}
                        </TabView>
                                                           
                                                            {(!["DID", "VMN", "TOLL FREE"].includes(["DID", "VMN", "TOLL FREE"][activeIndex])) && (
                                                                <div className="scroll-container">
                                                                    <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName = {rowClassName}>
                                                                        {(!isViewingAllocated && (isSuperAdmin || [USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN, USER_ROLES.CALL_CENTRE_ADMIN].includes(userRole))) && (
                                                                                <Column 
                                                                                    header={<Checkbox 
                                                                                    checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                                                    onChange={handleSelectAll} 
                                                                                />} 
                                                                                headerStyle={{ width: '3rem' }} 
                                                                                body={(rowData) => (
                                                                                <Checkbox 
                                                                                    checked={selectedNumbers.includes(rowData.id)} 
                                                                                    onChange={() => handleCheckboxToggle(rowData.id)} 
                                                                                />
                                                                            )} 
                                                                            />
                                                                        )} 
                                                                        
                                                                        <Column field="actual_number" filterField="actual_number" header="DID" filter filterPlaceholder="Search by Number" body={(rowData) => rowData.actual_number || '-'}></Column>
                                                                        <Column field="country_code" filterField="country_code" header="Country Code" filter filterPlaceholder="Search by Country Code" body={(rowData) => rowData.country_code || '-'}></Column>
                                                                        <Column field="state_code" filterField="state_code" header="State Code" filter filterPlaceholder="Search by State Code" body={(rowData) => rowData.state_code || '-'}></Column>
                                                                        <Column field="cost" filterField="cost" header="Cost" filter filterPlaceholder="Search by Cost" body={(rowData) => rowData.cost || '-'}></Column>
                                                                        <Column field="operator" filterField="operator" header="Operator" filter filterPlaceholder="Search by Operator" body={(rowData) => rowData.operator || '-'}></Column>
                                                                        <Column field="category" filterField="category" header="Category" filter filterPlaceholder="Search by Category" filterElement={categoryFilterTemplate} body={(rowData) => rowData.category || '-'}></Column>
                                                                        <Column field="currency" filterField="currency" header="Currency" filter filterPlaceholder="Search by Currency" filterElement={currencyFilterTemplate} body={(rowData) => rowData.currency || '-'}></Column>
                                                                        <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                                        <Column field="status" header="Status" filterElement={statusFilterTemplate} filter body={(rowData) => rowData.status || '-'}></Column>
                                                                        <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                                                        <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type"  body={(rowData) => rowData.routing_type || '-'}></Column>
                                                                        <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing"  body={(rowData) => rowData.routing_destination || '-'}></Column>
                                                                        <Column field="created_at" header="Created Date" body={(rowData) => {
                                            if (!rowData.created_at) return '-';
                                            const date = new Date(rowData.created_at);
                                            return date.toLocaleString("en-IN", {
                                                timeZone: "Asia/Kolkata",
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: true
                                            });
                                        }}></Column> 
                                                                        {isViewingAllocated && (
                                                                            <Column field="allocated_name" header="Allocated To"></Column> 
                                                                        )}
                                                                        {isViewingAllocated && (
                                                                            <Column field="allocated_by" header="Allocated By"></Column> 
                                                                        )}
                                                                    </DataTable>
                                                                </div>
                                                            )}      
                       
                    </div>
                  </Card.Body>
               </Card>
            </Col>
         </Row>

         <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Remove Numbers</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <MultiSelect
                            value={selectedAllocations}
                            options={allocatedNumber.map(number => ({ label: number.actual_number, value: number.id }))}
                            onChange={(e) => setSelectedAllocations(e.value)}
                            placeholder="Select Number"
                            className="w-100"
                            appendTo="self"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button label="Close" className="p-button-secondary" style={{ marginRight: '10px' }} onClick={handleCloseModal} />
                        <Button label="Remove" className="p-button-primary" onClick={handleRemoveAllocatedDIDs} />
                    </Modal.Footer>
                </Modal>

                <Modal show={voicePlan} onHide={handleCloseVoicePlanModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                        {(comingUserRole === 'company') ? 'Allocate Voice Plan To Company' : 'Allocate Voice Plan to Call Centers'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Dropdown
                            value={selectedPlan}
                            options={voicePlanOptions}
                            onChange={(e) => setSelectedVoicePlan(e.value)}
                            placeholder="Select Voice Plan"
                            className="w-100"
                            appendTo="self"
                            // optionDisabled="disabled"
                        />
                        {(comingUserRole === 'company') && (
                            <Dropdown
                                value={selectedCompany}
                                options={companyList.map(company => ({
                                    label: company.name,
                                    value: company.id
                                }))}
                                onChange={(e) => setSelectedCompany(e.value)}
                                placeholder="Select Company"
                                className="w-100"
                                disabled
                                appendTo="self"
                                style={{marginTop : '20px'}}
                            />
                        )}

                        {(comingUserRole === 'callcentre') && (
                            <Dropdown
                                value={selectedCallcenter}
                                options={callcenterList.map(callcenter => ({
                                    label: callcenter.name,
                                    value: callcenter.id
                                }))}
                                onChange={(e) => setSelectedCallcenter(e.value)}
                                disabled
                                placeholder="Select Callcenter"
                                className="w-100"
                                appendTo="self"
                                style={{marginTop : '20px'}}
                            />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button label="Close" className="p-button-secondary" style={{ marginRight: '10px' }} onClick={handleCloseVoicePlanModal} />
                        <Button label="Allocate" className="p-button-primary" onClick={handleAllocate} />
                    </Modal.Footer>
                </Modal>

         {/* show did result model */}
         <Modal show={showResultModal} onHide={() => setShowResultModal(false)} dialogClassName="w-100">
            <div style={{ maxWidth: '800px'}}>
                <Modal.Header closeButton>
                    <Modal.Title>Voice Plan Allocation Result</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {allocationResult && (
                    <>
                        {allocationResult.successActualNumbers?.length > 0 && (
                        <div className="mb-4">
                            <h5 className="text-success mb-2">✅ Voice Plan Allocated To:</h5>
                            <textarea
                            readOnly
                            rows={4}
                            className="form-control"
                            value={allocationResult.successActualNumbers.join('\n')}
                            />
                        </div>
                        )}

                        {allocationResult.failedDIDs?.length > 0 && (
                        <div>
                            <h5 className="text-danger mb-2">❌ Voice Plan Allocation Failed:</h5>
                            <textarea
                            readOnly
                            rows={4}
                            className="form-control"
                            value={allocationResult.failedDIDs
                                .map((fail) => `${fail.did} - ${fail.reason}`)
                                .join('\n')}
                            />
                        </div>
                        )}
                    </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button label="Close" className="p-button-secondary" onClick={() => setShowResultModal(false)} />
                </Modal.Footer>
            </div>
            
        </Modal>

         <Modal
                            show={showPlanModal}
                            onHide={() => setShowPlanModal(false)}
                            centered
                            >
                            <Modal.Header closeButton>
                                <Modal.Title>Plan Details - {selectedPlanName}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {selectedPlanDetails.length > 0 ? (
                                <div>
                                    {selectedPlanDetails.map((plan, index) => (
                                    <div key={index} style={{ marginBottom: '10px' }}>
                                        <strong>{plan.plan_type}</strong><br />
                                        Pulse Duration: {plan.pulse_duration}<br />
                                        Pulse Price: {plan.pulse_price}
                                    </div>
                                    ))}
                                </div>
                                ) : (
                                <div>No plan details available.</div>
                                )}
                            </Modal.Body>
                        </Modal>

            <Modal show={editVoicePlanModel} onHide={() => {
                setEditVoicePlanModel("")
                setSelectedEditVoicePlan("")
            }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                          Edit Voice Plan
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Dropdown
                            value={selectedEditPlan}
                            options={voicePlanList.map(plan => ({
                                label: plan.plan_name,
                                value: plan.id
                            }))}
                            onChange={(e) => setSelectedEditVoicePlan(e.value)}
                            placeholder="Select Voice Plan"
                            className="w-100"
                            appendTo="self"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button label="Close" className="p-button-secondary" style={{ marginRight: '10px' }} onClick={() => {
                            setEditVoicePlanModel("")
                            setSelectedEditVoicePlan("")
                        }} />
                        <Button label="Allocate" className="p-button-primary" onClick={handleUpdateVoicePlan} />
                    </Modal.Footer>
                </Modal>

       
       </div>
       {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

    </>
  )

}

export default UserAllocate;